import React, { useRef, useState } from "react";
import "./styles.css";
/**
 * @function UIPasswordInput 
 * @param {STRING} value - Allows us to set the value of the text input. 
 * @param {STRING} placeholder - Allows us to set the placeholder text. 
 * @param {FUNCTION} onChange - Applies value of text field to event handler whenever text is changed :: STRING, EVENT -> VOID.
 * @param {STRING} data-point - Data point that should be applied to the input field
 * @returns {React.Component}
 * @example
 * <UIPasswordInput value="Some value" placeholder="Some placeholder" onChange={(value, evt)=> console.log(`${value} is now the value of text input`)} />
 */

export default function UIPasswordInput(props) {
  const ref = useRef();
  const value = props.value ?? "";
  const placeholder = props.placeholder ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  const onChange = (evt) => { 
    if(props.onChange instanceof Function){
      props.onChange(ref.current.value, evt);
    }
  };

  return (
    <input autoComplete="new-password" type="password" ref={ref} className="ui-password-input" defaultValue={value} placeholder={placeholder} onChange={onChange} data-point={ point } />
  );
}
